























































































































































































































































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { State } from "vuex-class";
import Daterange from "@/mixins/daterange";
import { EDGE_DATE, BusinessLicenseTextConfig } from "@/config";
import * as api from "@/service/step-three";

@Component
export default class BusinessLicense extends Mixins(Daterange) {
  @Prop(Object) companyInfo!: any;
  @State bidType!: number;

  longChecked = false;
  end_date_hold: any = null; //用来清空截止日期
  modalVisible = false;
  licenseResult: number = 0

  get getTextConfig() {
    if (this.bidType === 7) {
      return BusinessLicenseTextConfig.personal;
    }
    return BusinessLicenseTextConfig.normal;
  }

  get rules() {
    if (this.bidType === 6)
      return {
        company_name: [
          {
            required: true,
            validator(rule: any, value: string, cb: Function) {
              value = value.trim();
              if (!value) {
                return cb(new Error("请填写公司英文名称"));
              }
              if (/[\u4e00-\u9fa5]/.test(value)) {
                return cb(new Error("公司名称不能包含中文"));
              }
              cb();
            },
          },
        ],
        country: [{ required: true, message: "请选择公司所在国家" }],
        pop_district: [{ required: true, message: "请填写州/省/地区" }],
        pop_city: [{ required: true, message: "请填写城市" }],
        company_address: [{ required: true, message: "请填写公司详细地址" }],
        postal_code: [
          { required: true, message: "请填写邮政编码" },
          { pattern: /^[a-zA-Z0-9]+$/, message: "邮政编码只能包含英文和数字" },
        ],
        pop_register_url: [
          { required: true, message: "请上传公司注册登记证照片" },
        ],
        pop_register_no: [
          { required: true, message: "请填写公司注册登记证编号" },
        ],
        establish_date: [{ required: true, message: "请选择成立日期" }],
      };
    if (this.bidType === 7) {
      return {
        business_license: [
          {
            required: true,
            message: "请填写18位统一社会信用代码或15位注册号",
            trigger: "blur",
          },
          {
            pattern: /^(([a-zA-Z0-9]{15})|([a-zA-Z0-9]{18}))$/,
            message: "格式不正确，请填写18位统一社会信用代码或15位注册号",
            trigger: "blur",
          },
        ],
        company_name: [
          {
            required: true,
            message: "请填写营业执照上的公司全称",
            trigger: "blur",
          },
          {
            pattern: /^\S+$/,
            message: "公司全称不能包含空格",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "请选择省市区",
            trigger: ["blur", "change"],
          },
        ],
        license_address: [
          {
            required: true,
            message: "请填写营业执照上的详细地址，需精确到门牌号",
            trigger: "blur",
          },
        ],
        establish_date: [
          {
            required: true,
            message: "请选择成立日期",
            trigger: ["blur", "change"],
          },
        ],
        business_scope: [
          {
            required: true,
            message: "请填写营业执照上的经营范围",
            trigger: "blur",
          },
          {
            max: 1000,
            message: "最多1000个字符",
            trigger: ["blur", "change"],
          },
        ],
        license_url: [
          {
            required: true,
            message: "请上传营业执照照片",
          },
        ],
      };
    }
    return {
      business_license: [
        {
          required: true,
          message: "请填写18位统一社会信用代码或15位注册号",
          trigger: "blur",
        },
        {
          pattern: /^(([a-zA-Z0-9]{15})|([a-zA-Z0-9]{18}))$/,
          message: "格式不正确，请填写18位统一社会信用代码或15位注册号",
          trigger: "blur",
        },
      ],
      company_name: [
        {
          required: true,
          message: "请填写营业执照上的公司全称",
          trigger: "blur",
        },
        {
          pattern: /^\S+$/,
          message: "公司全称不能包含空格",
          trigger: "blur",
        },
      ],
      address: [
        {
          required: true,
          message: "请选择省市区",
          trigger: ["blur", "change"],
        },
      ],
      license_address: [
        {
          required: true,
          message: "请填写营业执照上的详细地址，需精确到门牌号",
          trigger: "blur",
        },
      ],
      registered_capital: [
        {
          required: true,
          message: "请填写数字，支持两位小数",
          pattern: /^(\d+)(.\d{1,2})?$/,
          trigger: "change",
        },
      ],
      establish_date: [
        {
          required: true,
          message: "请选择成立日期",
          trigger: ["blur", "change"],
        },
      ],
      start_date: [
        {
          required: true,
          message: "请选择营业期限起始日期",
          trigger: ["blur", "change"],
        },
      ],
      end_date: [
        {
          required: true,
          message: "请选择营业期限截止日期",
          trigger: "blur",
        },
      ],
      business_scope: [
        {
          required: true,
          message: "请填写营业执照上的经营范围",
          trigger: "blur",
        },
        {
          max: 1000,
          message: "最多1000个字符",
          trigger: ["blur", "change"],
        },
      ],
      license_url: [
        {
          required: true,
          message: "请上传营业执照照片",
        },
      ],
    };
  }

  @Watch("companyInfo.end_date")
  setEndDate(val: string) {
    if (val === EDGE_DATE) {
      this.longChecked = true;
    } else {
      this.end_date_hold = val;
    }
  }

  onEndChange(e: any) {
    if (e.target.checked) {
      this.$emit("change", { end_date: EDGE_DATE });
      this.end_date_hold = null;
      this.validateField("end_date");
    } else {
      this.$emit("change", { end_date: null });
    }
  }

  validateField(name: string, time = 200) {
    const vm: any = this.$refs.ruleForm;
    setTimeout(() => {
      vm.validateField(name);
    }, time);
  }

  onDateChange(e: any) {
    this.$emit("change", { end_date: e });
    this.validateField("end_date");
    this.longChecked = false;
  }

  async validateCompany(e: any) {
    if (e.target.value) {
      try {
        await api.validateCompany(e.target.value);
      } catch (err) {
        this.$emit("change", { company_name: null });
        console.error(err);
      }
    }
  }

  validateForm() {
    return this.$refs.ruleForm;
  }

  async handleLicenseChange(info: any) {
    if (info.fileList?.length <= 0) return
    try {
      const data = await api.queryBusinessLicenseInfo(this.companyInfo.license_url)
      this.companyInfo = Object.assign(this.companyInfo, data || {})
      const { scope, ...rest } = data
      const obj = { 
        ...rest,
        business_scope: scope
      }
      this.$emit('change', obj)
      this.licenseResult = 1
    } catch (e) {
      this.licenseResult = -1
    }
  }
}
